/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enteryouremailtoreceivepasswordresetinstructions7Inputs */

const en_enteryouremailtoreceivepasswordresetinstructions7 = /** @type {(inputs: Enteryouremailtoreceivepasswordresetinstructions7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter your email to receive instructions for resetting your password`)
};

const de_enteryouremailtoreceivepasswordresetinstructions7 = /** @type {(inputs: Enteryouremailtoreceivepasswordresetinstructions7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gib deine E-Mail-Adresse ein, um Anweisungen zum Zurücksetzen deines Passworts zu erhalten`)
};

/**
* | output |
* | --- |
* | "Enter your email to receive instructions for resetting your password" |
*
* @param {Enteryouremailtoreceivepasswordresetinstructions7Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const enteryouremailtoreceivepasswordresetinstructions7 = /** @type {((inputs?: Enteryouremailtoreceivepasswordresetinstructions7Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enteryouremailtoreceivepasswordresetinstructions7Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enteryouremailtoreceivepasswordresetinstructions7(inputs)
	return de_enteryouremailtoreceivepasswordresetinstructions7(inputs)
});
export { enteryouremailtoreceivepasswordresetinstructions7 as "enterYourEmailToReceivePasswordResetInstructions" }